module.exports = __webpack_public_path__ + "img/huati1.9a46707b.png";